import React from 'react';
import styled, { css } from 'styled-components';
import { Snackbar as MuiSnackbar } from '@material-ui/core';

const Snackbar = styled(({ error, ...otherProps }) => <MuiSnackbar {...otherProps} />)`
  bottom: 16px;
  .MuiSnackbarContent-root {
    display: flex;
    justify-content: center;
    min-width: 0;
    padding: 6px 24px;
    color: ${({ theme }) => theme.palette.grey[300]};
    background-color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    line-height: 1.53;
    box-shadow: none;
    ${({ error, theme }) => error && css`
      color: ${theme.palette.error.main};
      background-color: ${theme.palette.error.light};
    `}
  }
`;

export default Snackbar;
